import React, { Fragment, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
// import BackArrow from "../assets/images/back-arrow.svg";
// import CameraIcon from "../assets/icons/camera.svg";
// import SaveIcon from "../assets/icons/save.svg";
// import DetectedIcon from "../../assets/icons/detected.svg";
import Recomand from "../../assets/icons/Recommendations.svg";

// import DetectedCard from "../../components/DetectedCard";
import AnalysisResult from "../../components/AnalysisCard";
// import PoreAnalysisZone from "../../components/PoreAnalysisZone";

import DarkSpots from "../../assets/icons/dark-spot2.svg";
import Wrinkles from "../../assets/icons/dark-spot.svg";
import MoistureIcon from "../../assets/icons/moisturizing.svg";
import RednessIcon from "../../assets/icons/red-blood-cells.svg";
import SkinFirmnessIcon from "../../assets/icons/skin-firming.svg";
import LowerEyelidIcon from "../../assets/icons/lower-eyelid.svg";
import UpperEyelidIcon from "../../assets/icons/upper-eyelid.svg";
import SkinRadianceIcon from "../../assets/icons/Skin-Radiance.svg";
import { Disclosure } from "@headlessui/react";
import { ReactComponent as Chevron } from "../../assets/icons/Chevron.svg";
// import { ReactComponent as Info } from "../../assets/icons/Info.svg";
import { ReactComponent as Caret } from "../../assets/icons/Caret.svg";
import { constants } from "../../utils/ranges";
import {
  Font,
  Document,
  Page,
  StyleSheet,
  View,
  Text,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { useAuth } from "../../utils/auth";
import { ReactComponent as Download } from "../../assets/icons/Download.svg";
import CarePlixLogo from "../../assets/images/CarePlixLogo.png";
import BodyVitalReportImage from "../../assets/images/BodyVitalReportImage.png";
import HeartRate from "../../assets/images/HeartRate.png";
import RespirationRate from "../../assets/images/RespirationRate.png";
import coverImageAll from "../../assets/images/coverImageAll.png";

const iconMap = {
  spots: DarkSpots,
  wrinkles: Wrinkles,
  dark_circles: DarkSpots,
  eye_bags: Wrinkles,
  moisture: MoistureIcon,
  oiliness: MoistureIcon,
  redness: RednessIcon,
  acne: DarkSpots,
  pores_full_face: DarkSpots,
  firmness: SkinFirmnessIcon,
  droopy_lower_eyelid: LowerEyelidIcon,
  droopy_upper_eyelid: UpperEyelidIcon,
  radiance: SkinRadianceIcon,
  tear_trough: DarkSpots,
};

Font.register({
  family: "Poppins",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf",
      fontWeight: "light",
    },
    {
      src: "https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf",
      fontWeight: "medium",
    },
    {
      src: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf",
      fontWeight: "semibold",
    },
    {
      src: "https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf",
      fontWeight: "bold",
    },
  ],
});

const PDFReport = ({
  name,
  age,
  gender,
  height,
  weight,
  hasDermaResult = false,
  result,
}) => {
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "#fff",
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "space-between",
    },
    header: {
      backgroundColor: "#f7f7f7",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingHorizontal: 24,
      paddingVertical: 16,
      borderBottom: 1,
      borderBottomColor: "#D3D3D3",
    },
    contentContainer: { flex: 1, paddingVertical: 12, paddingHorizontal: 24 },
    rowContainer: { flexDirection: "row", justifyContent: "space-between" },
    largeText: { fontFamily: "Poppins", fontSize: 15, fontWeight: "bold" },
    normalText: { fontFamily: "Poppins", fontSize: 12, fontWeight: "semibold" },
    smallText: { fontFamily: "Poppins", fontSize: 10 },
    footer: {
      height: 30,
      backgroundColor: "#192852",
      width: "100%",
    },
    coverPage: {
      backgroundColor: "#000068",
      padding: 0,
      height: "100%",
    },
    coverImageContainer: {
      width: "100%",
      height: "100%",
      backgroundColor: "#000068",
      alignItems: "center",
      justifyContent: "center",
    },
    coverImage: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
    coverLogo: {
      position: "absolute",
      top: 20,
      left: 20,
      width: 220,
      height: 75,
      objectFit: "contain",
      backgroundColor: "#FFF",
      borderRadius: 15,
    },
    coverTitleArea: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#F4F7F8",
      paddingVertical: 10,
      paddingHorizontal: 64,
      borderTopLeftRadius: 64,
      borderTopRightRadius: 64,
    },
    reportTitle: {
      fontSize: 24,
      fontWeight: "normal",
      textAlign: "center",
      marginBottom: 4,
      fontFamily: "Poppins",
    },
    reportSubtitle: {
      fontSize: 36,
      fontWeight: "bold",
      textAlign: "center",
      color: "#00ABFF",
      fontFamily: "Poppins",
    },
    headerText: {
      fontFamily: "Poppins",
      fontSize: 10,
      color: "#666",
    },
    circleContainer: {
      width: 130,
      height: 130,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#E9F3FF",
      borderRadius: 25,
      marginRight: 15,
      paddingVertical: 5,
      paddingHorizontal: 5,
    },

    titleText: {
      fontFamily: "Poppins",
      fontSize: 13,
      fontWeight: "600",
      color: "#1A1A1A",
      textAlign: "center",
      marginBottom: 8,
    },

    statusBox: {
      width: 80,
      height: 50,
      backgroundColor: "#FFFFFF",
      borderRadius: 30,
      justifyContent: "center",
      alignItems: "center",
      shadowColor: "#000",
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 3,
    },

    scoreText: {
      fontFamily: "Poppins",
      fontSize: 10,
      fontWeight: "400",
      color: "#5A5A5A",
      textAlign: "center",
    },
    tableContainer: {
      marginTop: 10,
      borderRadius: 10,
      overflow: "hidden",
    },
    tableHeaderRow: {
      flexDirection: "row",
      backgroundColor: "#2E5894",
      color: "#fff",
      paddingVertical: 5,
      paddingHorizontal: 12,
    },
    tableHeaderCell: {
      fontFamily: "Poppins",
      fontSize: 12,
      fontWeight: "bold",
      color: "#fff",
      flex: 1,
    },
    tableRow: {
      flexDirection: "row",
      backgroundColor: "#fff",
      borderBottom: "1px solid #eee",
      paddingVertical: 8,
      paddingHorizontal: 12,
      alignItems: "center",
    },
    tableCell: {
      fontFamily: "Poppins",
      fontSize: 12,
      color: "#333",
      flex: 1,
    },
    adjustedMuscleMassRow: {
      flexDirection: "row",
      backgroundColor: "#2E5894",
      color: "#fff",
      paddingVertical: 4,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    adjustedCell: {
      fontFamily: "Poppins",
      fontSize: 12,
      fontWeight: "bold",
      color: "#fff",
    },
    disclaimerContainer: {
      marginTop: 30,
      padding: 15,
      borderRadius: 10,
      backgroundColor: "#F4F7F8",
      border: "1px solid #eee",
    },
    disclaimerText: {
      fontFamily: "Poppins",
      fontSize: 9,
      fontWeight: "normal",
      color: "#666",
      textAlign: "justify",
    },
    bodyVitalsContainer: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#2E5894",
      borderRadius: 12,
      paddingHorizontal: 10,
      paddingVertical: 8,
      width: "100%",
    },
    textContainer: {
      flex: 1,
    },
    bodyVitalstitle: {
      fontSize: 16,
      fontWeight: 700,
      color: "#FFFFFF",
      marginBottom: 4,
    },
    highlight: {
      color: "#4BA3F2",
    },
    bodyVitalSubtitle: {
      fontSize: 10,
      color: "#DADADA",
    },
    bodyVitalsImage: {
      width: 70,
      height: 40,
      objectFit: "contain",
    },
    stressBox: {
      marginTop: 15,
      padding: 15,
      borderRadius: 10,
      backgroundColor: "#f7f7f7",
      border: "1px solid #eee",
    },
  });

  const getFacialMetric = (key) => {
    const val = result?.facial_analysis?.[key];
    if (!val) return null;

    const statusLabel = val.severity || val.level || val.visibility || "N/A";

    const statusColor =
      statusLabel === "low"
        ? "#22C55E"
        : statusLabel === "mild"
        ? "#84CC16"
        : statusLabel === "moderate"
        ? "#FACC15"
        : statusLabel === "high"
        ? "#EF4444"
        : statusLabel === "severe"
        ? "#DC2626"
        : "#374151";

    return {
      Score: val.confidence ? `${Math.round(val.confidence * 100)}%` : "N/A",
      status: {
        label:
          statusLabel === "needs_attention"
            ? "Needs Attention"
            : statusLabel.charAt(0).toUpperCase() + statusLabel.slice(1),
        color: statusColor,
      },
    };
  };

  const facialMetricsConfig = [
    { label: "Redness", key: "redness" },
    { label: "Dark Circles", key: "dark_circles" },
    { label: "Eye Bags", key: "eye_bags" },
  ];

  const hasFacialData = facialMetricsConfig.some(
    (item) => result?.facial_analysis?.[item.key]
  );

  return (
    <Document
      title="CarePlix Report"
      subject="Report generated from CarePlix Vitals Scan"
      author="CarePlix"
    >
      {/* <Page size="A4" style={styles.page}>
        <View style={styles.coverPage}>
          <Image style={styles.coverLogo} src={CarePlixLogo} />

          <View style={styles.coverTitleArea}>
            <Text style={styles.reportSubtitle}>UnityHealth</Text>
            <Text style={styles.reportTitle}>Assessment Report</Text>
          </View>

          <View style={styles.coverImageContainer}>
            <Image style={styles.coverImage} src={coverImageAll} />
          </View>
        </View>
      </Page> */}
      <Page style={styles.page}>
        <View fixed style={styles.header}>
          <View>
            <Text
              style={{ color: "#00ABFF", fontWeight: "bold", fontSize: 18 }}
            >
              Digital Health
            </Text>
            <Text style={{ fontWeight: "normal", fontSize: 20 }}>
              Facial Biomarker Intelligence Report
            </Text>
          </View>
          <Text style={styles.headerText}>
            Date & Time:{" "}
            {new Date(result.timestamp).toLocaleDateString("en-GB")}
            {", "}
            {new Date(result.timestamp).toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </Text>
        </View>
        <View style={styles.contentContainer}>
          <View style={styles.rowContainer}>
            <View style={{ flex: 1.5, paddingRight: 40 }}>
              {[
                { label: "Name", value: name },
                { label: "Age", value: `${age} years` },
                { label: "Gender", value: gender },
                { label: "Height", value: `${height} cms` },
                { label: "Weight", value: `${weight} kgs` },
              ].map(({ label, value }) => (
                <Text
                  key={label.toLowerCase().replaceAll(" ", "-")}
                  style={[
                    styles.normalText,
                    {
                      fontWeight: "normal",
                      marginTop: label === "Name" ? 0 : 8,
                      borderBottom: 1,
                      borderBottomColor: "#E7E7E7",
                    },
                  ]}
                >
                  <Text style={{ fontWeight: "semibold", minWidth: 60 }}>
                    {label} :
                  </Text>
                  <Text
                    style={{
                      textTransform: label === "Name" ? "capitalize" : "none",
                    }}
                  >
                    {` ${value}`}
                  </Text>
                </Text>
              ))}
            </View>
            {result.overallScore !== null && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: 10,
                }}
              >
                <View style={styles.circleContainer}>
                  <Text style={styles.titleText}>Overall Skin Health</Text>
                  <View style={styles.statusBox}>
                    <Text style={styles.scoreText}>{result.overallScore}</Text>
                  </View>
                </View>
              </View>
            )}
          </View>

          <Text
            style={{
              fontWeight: "semibold",
              fontSize: 12,
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            Facial Analysis
          </Text>

          <View style={styles.tableContainer}>
            <View style={styles.tableHeaderRow}>
              <Text style={[styles.tableHeaderCell, { flex: 2.5 }]}>
                Parameter
              </Text>
              <Text style={[styles.tableHeaderCell, { flex: 1.5 }]}>
                Confidence
              </Text>
              <Text style={[styles.tableHeaderCell, { flex: 1 }]}>
                Severity
              </Text>
            </View>
            {hasDermaResult ? (
              facialMetricsConfig.map((item, index) => {
                const metric = getFacialMetric(item.key);
                if (!metric) return null;

                return (
                  <View style={styles.tableRow} key={index}>
                    <Text style={[styles.tableCell, { flex: 2.5 }]}>
                      {item.label}
                    </Text>

                    <Text style={[styles.tableCell, { flex: 1.5 }]}>
                      {metric.Score}
                    </Text>

                    <View style={[styles.tableCell, { flex: 1 }]}>
                      <Text
                        style={{ color: metric.status.color, fontSize: 10 }}
                      >
                        {metric.status.label}
                      </Text>
                    </View>
                  </View>
                );
              })
            ) : (
              <View style={styles.tableRow}>
                <Text
                  style={{
                    flex: 1,
                    textAlign: "center",
                    fontSize: 10,
                    fontStyle: "italic",
                    color: "#9CA3AF",
                    paddingVertical: 10,
                  }}
                >
                  There is no Facial Analysis result to show.
                </Text>
              </View>
            )}
          </View>

          <View style={styles.disclaimerContainer}>
            <Text
              style={[
                styles.largeText,
                { marginTop: 2, marginBottom: 8, fontSize: 10 },
              ]}
            >
              Disclaimer
            </Text>
            <Text style={styles.disclaimerText}>
              For <Text style={styles.boldText}>Investigational Use Only</Text>.
              This scan is not a substitute for the clinical judgement of a
              health care professional. This scan is intended to improve you
              awareness of general wellness. This scan does not diagnose, treat,
              mitigate or prevent any disease, symptom, disorder or abnormal
              physical state. Consult with a healthcare professional or
              emergency services if you believe you may have a medical issue.
            </Text>
          </View>
        </View>
        <View style={styles.contentContainer} break>
          <View style={styles.bodyVitalsContainer}>
            <View style={styles.textContainer}>
              <Text style={styles.bodyVitalstitle}>
                Key Body <Text style={styles.highlight}>Vitals</Text>
              </Text>
              <Text style={styles.bodyVitalSubtitle}>
                Monitoring essential health metrics for optimal wellness
              </Text>
            </View>

            <Image src={BodyVitalReportImage} style={styles.bodyVitalsImage} />
          </View>
          <View style={styles.tableContainer}>
            <View style={styles.tableHeaderRow}>
              <Text style={[styles.tableHeaderCell, { flex: 2 }]}>
                Key Body Vitals
              </Text>
              <Text style={[styles.tableHeaderCell, { flex: 1.5 }]}>Value</Text>
              <Text style={[styles.tableHeaderCell, { flex: 1.5 }]}>
                Normal Range
              </Text>
            </View>
            {[
              {
                label: "Heart Rate",
                value: `${result.heart_rate} BPM`,
                status: constants["Heart Rate"].ranges["resting"]?.reduce?.(
                  (p, c) => (result.heart_rate >= c.point ? c : p)
                ) || { label: "Unknown", color: "#000" },
                range: "60 - 100 BPM",
              },
              {
                label: "Respiration Rate",
                value: `${result.resp_rate} breaths/min`,
                status: constants["Respiration Rate"].ranges.reduce((p, c) =>
                  result.resp_rate >= c.point ? c : p
                ) || { label: "Unknown", color: "#000" },
                range: "12 - 20/min",
              },
              {
                label: "Pulse Respiration Quotient",
                value: `${result.prq}`,
                status: constants["Pulse Respiration Quotient"].ranges[
                  result?.posture ?? "resting"
                ]?.reduce((p, c) => (result.prq >= c.point ? c : p)) || {
                  label: "Unknown",
                  color: "#000",
                },
                range: "0 - 10",
              },
            ].map((item, index) => (
              <View style={styles.tableRow} key={index}>
                <Text
                  style={[
                    styles.tableCell,
                    { flex: 2, fontWeight: "semibold" },
                  ]}
                >
                  {item.label}
                </Text>
                <View style={{ flex: 1.5, flexDirection: "column" }}>
                  <Text
                    style={[styles.tableCell, { padding: 0, borderBottom: 0 }]}
                  >
                    {item.value}
                  </Text>
                  <Text
                    style={[
                      styles.smallText,
                      {
                        fontFamily: "Poppins",
                        fontSize: 8,
                        color: item.status?.color || "#000",
                        fontWeight: "bold",
                        marginTop: 20,
                      },
                    ]}
                  >
                    {item.status?.label || ""}
                  </Text>
                </View>
                <Text style={[styles.tableCell, { flex: 1.5 }]}>
                  {item.range}
                </Text>
              </View>
            ))}
          </View>

          <Text style={[styles.largeText, { marginTop: 40, marginBottom: 30 }]}>
            Health Parameters Description
          </Text>
          {[
            {
              icon: HeartRate,
              title: "Heart Rate",
              desc: "The heart rate is the number of times heart beats in a minute (bp 4). A normal resting heart rate for adults ranges from 60 to 100 beats per minute. A person's resting heart rate is the heart rate during physical activity and exercise. A normal resting heart rate for adults ranges from 60 to 100 bpm.",
            },
            {
              icon: RespirationRate,
              title: "Respiration Rate",
              desc: "The respiration rate is the number of breaths taken in a minute. The rate is usually measured when a person is at rest and simply involves counting the number of breaths for one minute by counting how many times the chest rises.",
            },
            {
              icon: RespirationRate,
              title: "Pulse Respiration Quotient",
              desc: "Pulse Respiration Quotient (PRQ) is the ratio of heart rate to respiratory rate. It reflects the balance between cardiovascular and respiratory systems and is useful for assessing physiological stress, fitness level, and autonomic regulation.",
            },
          ].map(({ title, desc, icon }) => (
            <View
              key={`info-${title.toLowerCase().replaceAll(" ", "-")}`}
              style={{ marginBottom: 30, flexDirection: "row" }}
              wrap={false}
            >
              <View
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 6,
                  backgroundColor: "#EAF5FF",
                  border: "1px solid #A7CDF3",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: 8,
                }}
              >
                <Image
                  src={icon}
                  style={{
                    width: 20,
                    height: 20,
                  }}
                />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={[
                    styles.normalText,
                    { fontWeight: "bold", fontSize: 12, color: "#333" },
                  ]}
                >
                  {title}
                </Text>
                <Text
                  style={[
                    styles.smallText,
                    {
                      fontWeight: "light",
                      textAlign: "justify",
                      marginTop: 2,
                      color: "#666",
                    },
                  ]}
                >
                  {desc}
                </Text>
              </View>
            </View>
          ))}
        </View>

        <View style={styles.contentContainer} break>
          {result.aqi !== null && (
            <>
              <View style={[styles.bodyVitalsContainer]}>
                <View style={styles.textContainer}>
                  <Text style={styles.bodyVitalstitle}>
                    Environmental <Text style={styles.highlight}>Analysis</Text>
                  </Text>
                  <Text style={styles.bodyVitalSubtitle}>
                    Check your locations Air Quality Index(AQI)
                  </Text>
                </View>
              </View>
              <View style={styles.tableContainer}>
                <View style={styles.tableHeaderRow}>
                  <Text style={[styles.tableHeaderCell, { flex: 2 }]}>
                    AQI Level
                  </Text>
                  <Text style={[styles.tableHeaderCell, { flex: 1.5 }]}>
                    Value
                  </Text>
                  <Text style={[styles.tableHeaderCell, { flex: 1.5 }]}>
                    Normal Range
                  </Text>
                </View>
                {[
                  {
                    label: "Air Quality Index(AQI)",
                    value: result.aqi,
                    status:
                      constants["Air Quality Index"].ranges.ambient
                        .slice()
                        .reverse()
                        .find((r) => result?.aqi >= r.point) || {},
                    range: "0-50",
                  },
                ].map((item, index) => (
                  <View style={styles.tableRow} key={index}>
                    <Text
                      style={[
                        styles.tableCell,
                        { flex: 2, fontWeight: "semibold" },
                      ]}
                    >
                      {item.label}
                    </Text>
                    <View style={{ flex: 1.5, flexDirection: "column" }}>
                      <Text
                        style={[
                          styles.tableCell,
                          { padding: 0, borderBottom: 0 },
                        ]}
                      >
                        {item.value}
                      </Text>
                      <Text
                        style={[
                          styles.smallText,
                          {
                            fontFamily: "Poppins",
                            fontSize: 9,
                            color: item.status.color || "#000",
                            fontWeight: "bold",
                            marginTop: 20,
                          },
                        ]}
                      >
                        {item.status.label || ""}
                      </Text>
                    </View>
                    <Text style={[styles.tableCell, { flex: 1.5 }]}>
                      {item.range}
                    </Text>
                  </View>
                ))}
              </View>
              <View style={styles.stressBox}>
                <Text style={[styles.largeText, { fontSize: 10 }]}>
                  Your Air Quality is
                  {` ${
                    constants["Air Quality Index"].ranges.ambient
                      .slice()
                      .reverse()
                      .find((r) => result?.aqi >= r.point)?.label
                  }` || "Unknown"}
                </Text>
                <Text style={styles.smallText}>
                  Air Quality Index (AQI) is a standardized measure used to
                  communicate how polluted the air currently is and its
                  potential health impact. Higher AQI values indicate greater
                  levels of air pollution and increased health risk.
                </Text>
              </View>
              <View style={styles.disclaimerContainer}>
                <Text
                  style={[
                    styles.largeText,
                    { marginTop: 10, marginBottom: 5, fontSize: 10 },
                  ]}
                >
                  Disclaimer
                </Text>
                <Text style={styles.disclaimerText}>
                  For{" "}
                  <Text style={styles.boldText}>Investigational Use Only</Text>.
                  This scan is not a substitute for the clinical judgment of a
                  health care professional. This scan is intended to improve
                  your awareness of general wellness. This scan does not
                  diagnose, treat, mitigate or prevent any disease, symptom,
                  disorder or abnormal physical state. Consult with a healthcare
                  professional or emergency services if you believe you may have
                  a medical issue
                </Text>
              </View>
            </>
          )}
        </View>
        <View fixed style={styles.footer} />
      </Page>
    </Document>
  );
};

const VitalsDerma = () => {
  const {
    userData: { fname, lname, dob, gender, height, weight },
  } = useAuth();
  const { state } = useLocation();
  const result = state?.dermaResult?.analysis;
  const capturedImage = state?.dermaResult?.image;
  const vitals = state?.scanResult;

  const allowedKeys = ["redness", "dark_circles", "eye_bags"];

  const Range = ({
    ranges = [
      { point: 0, label: "Start", color: "#ccc" },
      { point: 100, label: "End", color: "#000" },
    ],
    selectedIndex,
    className = "",
  }) => {
    selectedIndex -= ranges.length - 1 === selectedIndex;
    return (
      <div className={`relative grid grid-flow-col auto-cols-fr ${className}`}>
        {ranges.slice(0, -1).map((rangeItem, index, list) => (
          <div key={`range-${index}`} className="flex flex-col justify-end">
            {index === selectedIndex && (
              <Caret
                className="self-center shrink-0 w-2 h-1"
                style={{ color: ranges[selectedIndex].color }}
              />
            )}
            <h6
              className="opacity-60 text-center text-xxs font-medium uppercase truncate"
              style={
                index === selectedIndex
                  ? { color: ranges[selectedIndex].color }
                  : {}
              }
            >
              {rangeItem.label}
            </h6>
            <div
              className="my-1 h-1"
              style={{
                backgroundColor:
                  index === selectedIndex
                    ? ranges[selectedIndex].color
                    : "#d4d8e2",
                borderTopLeftRadius: index === 0 ? 9999 : undefined,
                borderBottomLeftRadius: index === 0 ? 9999 : undefined,
                borderTopRightRadius:
                  index === list.length - 1 ? 9999 : undefined,
                borderBottomRightRadius:
                  index === list.length - 1 ? 9999 : undefined,
              }}
            />
            <p className="opacity-70 text-xxs">{rangeItem.point}</p>
          </div>
        ))}
        <p className="absolute bottom-0 right-0 opacity-70 text-xxs">
          {ranges[ranges.length - 1].point}
        </p>
      </div>
    );
  };

  const ListItemContainer = ({
    disabled = false,
    label = "",
    defaultExpanded = false,
    title,
    desc,
    className = "",
    ...props
  }) => {
    return (
      <Disclosure
        defaultOpen={defaultExpanded}
        as="div"
        className={`mx-6 px-4 py-4 rounded-[20px] border border-black/10 bg-[#F9F9F9] text-black ${className}`}
      >
        <Disclosure.Button as="div" disabled={disabled}>
          {({ open }) => [
            <div
              key="list-item-container-head"
              className="flex items-start justify-between space-x-1"
            >
              <h2 className="text-sm font-medium text-[#4D6698]">{label}</h2>
              <Chevron
                className={`h-3 w-3 opacity-70 transition-transform duration-300 ${
                  open ? "rotate-180" : "rotate-0"
                }`}
              />
            </div>,
            <Fragment key="list-item-container-body">
              {props.children}
            </Fragment>,
          ]}
        </Disclosure.Button>
        <Disclosure.Panel>
          {typeof title === "string" && (
            <h5 className="mt-2.5 text-[#4D6698] text-xs font-medium">
              {title}
            </h5>
          )}
          {typeof desc === "string" && (
            <p className="mt-1.5 text-xxs font-light leading-tight whitespace-pre-line">
              {desc}
            </p>
          )}
        </Disclosure.Panel>
      </Disclosure>
    );
  };

  const reportPDF = useMemo(() => {
    const ageDifMs = Date.now() - new Date(dob).getTime();
    const ageDate = new Date(ageDifMs);
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);

    const hasDermaResult = Boolean(
      state?.dermaResult?.analysis?.overall_skin_health
    );
    return (
      <PDFReport
        name={`${fname} ${lname}`}
        age={age}
        gender={gender.slice(0, 1).toUpperCase() + gender.slice(1)}
        height={height}
        weight={weight}
        hasDermaResult={hasDermaResult}
        result={{
          timestamp: new Date(
            state?.scanResult?.entry_time?.replace?.(" ", "T") ?? Date.now()
          ),
          overallScore:
            state?.dermaResult?.analysis?.overall_skin_health ?? null,
          facial_analysis:
            state?.dermaResult?.analysis?.facial_analysis ?? null,
          resp_rate: state?.scanResult?.vitals?.resp_rate ?? 0,
          heart_rate: state?.scanResult?.vitals?.heart_rate ?? 0,
          prq: state?.scanResult?.metadata?.cardiovascular?.prq ?? 0,
          aqi: state?.environmentalData?.aqi ?? null,
        }}
      />
    );
  }, [state, fname, lname, dob, gender, height, weight]);

  return (
    <section className="pt-2 flex flex-col">
      {/* <div className="flex items-center px-6 mb-6 tab-screen lg:mb-8 md:mb-8">
        <Link
          to="https://gitex-demo.careplix.com/UnityHealthExperienceCenter"
          className="w-9 h-9 bg-[#2D2D2D] rounded-full flex justify-center items-center"
        >
          <img src={BackArrow} alt="Back" />
        </Link>
        <h2 className="text-xl lg:text-2xl md:text-2xl font-medium text-white ml-6">
          Derma <span className="text-secondary">Ai</span>
        </h2>
        <div></div>
      </div> */}
      {state?.dermaResult && (
        <>
          <h3 className="text-base font-semibold text-white mb-2 text-center">
            Assessment Result
          </h3>
          <p className="text-xs text-white text-center mb-6">
            {`AI analysis for your "${
              state?.dermaResult?.selectedArea
            }" — ${new Date().toLocaleDateString()}`}
          </p>

          {/* Clinical Assessment */}
          <div className="px-6 mb-6 relative z-50 tab-screen">
            <div className="bg-[#1D1D1D]/70 rounded-[20px] p-6 text-center">
              {capturedImage ? (
                <img
                  src={capturedImage}
                  className="w-[300px] h-[225px] object-cover rounded-2xl mx-auto"
                  alt="Captured Skin"
                />
              ) : (
                <span className="text-white text-sm">No image available</span>
              )}
              <p className="text-white text-xl mt-5">
                Overall Skin Health:{" "}
                <span
                  className={`text-xl font-bold ${
                    {
                      excellent: "text-green-700",
                      good: "text-green-500",
                      fair: "text-yellow-500",
                      needs_attention: "text-red-500",
                    }[result.overall_skin_health] || "text-gray-500"
                  }`}
                >
                  {result.overall_skin_health === "needs_attention"
                    ? "Need Attention"
                    : result.overall_skin_health.charAt(0).toUpperCase() +
                      result.overall_skin_health.slice(1)}
                </span>
              </p>
              <p className="text-white/80 text-xs mt-2">
                {result.clinical_explanation}
              </p>
              {result.should_see_dermatologist && (
                <p className="text-red-400 mt-2 font-semibold">
                  We recommend seeing a dermatologist.
                </p>
              )}
            </div>
          </div>
        </>
      )}
      {/* Detected Conditions */}
      <div className="bg-white pb-20 pt-6 mt-8">
        <div className="tab-screen space-y-4">
          {/* {result?.detected_conditions?.length > 0 && (
            <div className="px-6 w-full">
              <div className="bg-[#F6F6F6] p-6 rounded-t-xl lg:rounded-xl md:rounded-xl">
                <div className="flex items-center mb-4">
                  <img src={DetectedIcon} className="mr-2" alt="" />
                  <h4 className="text-base font-medium text-black">
                    Detected Conditions
                  </h4>
                </div>
                <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4">
                  {result?.detected_conditions.map((c, i) => (
                    <DetectedCard
                      key={i}
                      title={c.condition}
                      severity={c.severity}
                      confidence={`${Math.round(
                        c.confidence * 100
                      )}% confidence`}
                      description={c.description}
                    />
                  ))}
                </div>
              </div>
            </div>
          )} */}

          {/* Facial Analysis */}
          <div className="flex items-center px-6 w-full">
            <div className="w-9 h-9 bg-[#EDF4FB] rounded-full flex items-center justify-center mr-3">
              <img src={iconMap.spots} alt="" className="w-6 h-6" />
            </div>
            <h4 className="text-base font-medium text-black">
              Vital and Environment Analysis
            </h4>
          </div>
          {[
            { label: "Heart Rate", value: vitals?.vitals.heart_rate },
            {
              label: "Respiration Rate",
              value: vitals?.vitals.resp_rate,
            },
            {
              label: "Pulse Respiration Quotient",
              value: vitals?.metadata.cardiovascular.prq,
            },
            {
              label: "Air Quality Index",
              value: state?.environmentalData?.aqi,
            },
          ]
            .filter((item) => item.value !== null && item.value !== undefined)

            .map((item, index) => {
              const ranges =
                item.label === "Heart Rate"
                  ? constants[item.label].ranges[result?.posture ?? "resting"]
                  : item.label === "Pulse Respiration Quotient"
                  ? constants[item.label].ranges[result?.posture ?? "resting"]
                  : item.label === "Air Quality Index"
                  ? constants[item.label].ranges.ambient
                  : constants[item.label].ranges;

              const selectedRangeIndex = ranges.reduce(
                (p, c, ci) => (item.value >= c.point ? ci : p),
                0
              );
              return (
                <ListItemContainer
                  key={`section-item-${index}`}
                  label={item.label}
                  title={`Your ${item.label} is ${ranges[selectedRangeIndex].label}`}
                  desc={
                    constants[item.label].info +
                    "\n\n" +
                    ranges[selectedRangeIndex].desc
                  }
                >
                  <div className="py-3 flex items-center justify-between space-x-2">
                    <div className="shrink-0 basis-1/4 text-center font-semibold">
                      <h4 className="text-primary text-xl">{item.value}</h4>
                      <h5 className="opacity-70 text-xxs">
                        {constants[item.label].unit}
                      </h5>
                    </div>
                    <Range
                      className="grow"
                      ranges={ranges}
                      selectedIndex={selectedRangeIndex}
                    />
                  </div>
                </ListItemContainer>
              );
            })}
          {result?.facial_analysis && (
            <div className="px-6 w-full">
              <div className="flex items-center">
                <div className="w-9 h-9 bg-[#EDF4FB] rounded-full flex items-center justify-center mr-3">
                  <img src={iconMap.spots} alt="" className="w-6 h-6" />
                </div>
                <h4 className="text-base font-medium text-black">
                  Comprehensive Facial Analysis
                </h4>
              </div>
              <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 lg:gap-2 md:gap-2 mt-4">
                {Object.entries(result.facial_analysis)
                  .filter(([key]) => allowedKeys.includes(key))
                  .map(([key, val], idx) => {
                    const icon = iconMap[key] || DarkSpots;

                    const labelMap = {
                      redness: "Facial Redness",
                      dark_circles: "Dark Circles",
                      eye_bags: "Eye Bags",
                    };

                    const severityOrLevel =
                      val.severity || val.level || val.visibility || "N/A";

                    const confidence = val.confidence
                      ? `${Math.round(val.confidence * 100)}%`
                      : "";

                    return (
                      <AnalysisResult
                        key={idx}
                        icon={icon}
                        title={labelMap[key]}
                        severity={severityOrLevel}
                        confidence={confidence}
                        description={val.description}
                      />
                    );
                  })}
              </div>

              {/* <PoreAnalysisZone
                zones={[
                  {
                    label: "T Zone",
                    severity:
                      result.facial_analysis.pores_detailed_zones.t_zone,
                    confidence: 0,
                  },
                  {
                    label: "Cheek Area",
                    severity:
                      result.facial_analysis.pores_detailed_zones.cheek_area,
                    confidence: 0,
                  },
                  {
                    label: "Chin Area",
                    severity:
                      result.facial_analysis.pores_detailed_zones.chin_area,
                    confidence: 0,
                  },
                ]}
              /> */}
            </div>
          )}

          {/* Recommendations */}
          <div className="px-6">
            {/* <div className="flex items-center mb-4">
              <img src={Recomand} className="mr-2" alt="" />
              <h4 className="text-base font-medium text-black">
                Care Recommendations
              </h4>
            </div>
            {Object.entries(result.recommendations).map(
              ([title, content], i) => (
                <div
                  key={i}
                  className="bg-[#2E3A59] text-white text-xs rounded-[10px] px-4 py-3 mb-2 flex"
                >
                  <span className="mr-2">{i + 1}.</span>
                  <span>{content}</span>
                </div>
              )
            )} */}

            {/* Navigation Buttons */}
            <Link
              to={-2}
              className="block mt-8 px-6 py-3 lg:w-1/2 md:w-1/2 w-full mx-auto rounded-full outline-none border border-primary/80 bg-white text-primary text-center text-sm font-light"
            >
              Back
            </Link>
            <PDFDownloadLink
              className="flex items-center justify-between space-x-4 py-3 px-6 rounded-full bg-black text-white text-sm font-medium mt-5"
              document={reportPDF}
              fileName="Facial-Biomarker-Intelligence-Report"
            >
              {({ loading }) => (
                <>
                  <span>
                    {loading ? "Loading document..." : "Download PDF Report"}
                  </span>
                  <Download className="flex-shrink-0 h-6 w-6" />{" "}
                </>
              )}
            </PDFDownloadLink>
            {/* <div className="mt-4 grid grid-cols-2 gap-3">
              <Link
                to="/skin-analyzer"
                className="bg-black text-white py-3 rounded-full flex items-center justify-center gap-2 text-sm shadow"
              >
                <img src={CameraIcon} alt="" /> New Analysis
              </Link>
              <button
                onClick={() => alert("Saved!")}
                className="border border-gray-400 text-gray-900 py-3 rounded-full flex items-center justify-center gap-2 text-sm"
              >
                <img src={SaveIcon} alt="" /> Save Results
              </button>
              </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VitalsDerma;
